import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';
import { IconoirInfoCircle } from '@ey-xd/motif-icon';
import { MotifModule } from "@ey-xd/motif-wc-angular"; 
import { MotifProgressIndicator, MotifProgressIndicatorStep } from "@ey-xd/motif-wc-angular";

@Component({
  selector: 'app-tb-agent-summary',
  standalone: true,
  imports: [MotifModule, CommonModule],
  templateUrl: './tb-agent-summary.component.html',
  styleUrl: './tb-agent-summary.component.scss',
})
export class TbAgentSummaryComponent {
  IconoirInfoCircle = IconoirInfoCircle;
  hoverableRecordsCleansed: string =
    'A cleansed file is a processed version of the original trial balance, where formatting inconsistencies, errors, or unnecessary data have been removed to ensure accurate extraction and analysis.';
  hoverableRecordsRemoved: string =
    'Records may have been removed based on the following rules: records where both Account Code and Account Description are empty, records with empty Account Codes, records with invalid Account Codes (e.g., IP-like values), and sub-total/total rows';

  private _cleansingSummary!: any;

  @Input()
  set cleansingSummary(value: any) {
    this._cleansingSummary = value;
  }

  get cleansingSummary(): any {
    return this._cleansingSummary;
  }

  constructor() {}
}
